import {
  GET_ALL_PARTNERS_FAILED,
  GET_ALL_PARTNERS_LOADING,
  GET_ALL_PARTNERS_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export const getAllPartnersReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_ALL_PARTNERS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_ALL_PARTNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_ALL_PARTNERS_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error,
      };
    default:
      return state;
  }
};
